import React from "react";
import PropTypes from "prop-types";
import Modal, { MODAL_SIZE } from "components/Modal";
import { NetworkList, NetworkListControls } from "components/Network";
import { Grid } from "components/Containers";
import { useNetworkControls } from "hooks";

/**
 * SearchModal
 *
 * @param {Object}    initialValues
 * @param {Boolean}   show
 * @param {Function}  onClose
 * @param {Array}     actions
 * @param {Boolean}   isCardView
 * @param {Function}  onItemClick
 */
const SearchModal = ({ initialValues, show, onClose, actions, isCardView, onItemClick, ...props }) => {
  const resultsPerPage = 18;
  const {
    filterMetadata,
    data: profilesData,
    ...rest
  } = useNetworkControls({
    resultsPerPage,
    initialValues,
  });

  return (
    <Modal
      show={show}
      onClose={onClose}
      showSave={false}
      showCancel={true}
      secondaryButtonMessageId="Global.Close"
      size={MODAL_SIZE.xlarge}
      {...props}
    >
      <Grid topMargin>
        <Grid.col start={1} end={13}>
          <NetworkListControls formValues={filterMetadata} hideSorts {...rest} />
        </Grid.col>
        <Grid.col start={1} end={13}>
          <NetworkList
            actions={actions}
            data={profilesData}
            isCardView={isCardView}
            onItemClick={onItemClick}
            {...rest}
          />
        </Grid.col>
      </Grid>
    </Modal>
  );
};

SearchModal.propTypes = {
  initialValues: PropTypes.object,
  show: PropTypes.bool,
  onClose: PropTypes.func,
  actions: PropTypes.array,
  isCardView: PropTypes.bool,
  onItemClick: PropTypes.func,
};

SearchModal.defaultProps = {
  actions: [],
};

export default SearchModal;
